import React, { useState } from 'react';

const columns = [
  'Load #',
  'Driver',
  'Customer',
  'Movement',
  'Load Status',
  'Container',
  'Reference #',
  'Billing Date',
  'Invoice Amount ',
  'Payment Received',
  'Outstanding',
  'Payment',
];

const data = [
  {
    id: 1,
    invoice: 'POP2_M100520',
    driver: 'Robert Fox',
    img: 'https://themesbrand.com/minible/layouts/assets/images/users/avatar-2.jpg',
    customer: 'OEC Group',
    status: 'Dropped',
    movement: 'Movement',
    container: 'SDEE4125554',
    reference: 'SDEE4125554',
    billDate: '06/11',
    invoiceAmt: '00.00',
    paymentReceived: '00.00',
    outstanding: '00.00',
    payment: '0.00',
  },
  {
    id: 2,
    invoice: 'POP2_M100520',
    driver: 'Robert Fox',
    img: 'https://themesbrand.com/minible/layouts/assets/images/users/avatar-2.jpg',
    customer: 'OEC Group',
    status: 'Dropped',
    movement: 'Movement',
    container: 'SDEE4125554',
    reference: 'SDEE4125554',
    billDate: '06/11',
    invoiceAmt: '00.00',
    paymentReceived: '00.00',
    outstanding: '00.00',
    payment: '0.00',
  },
  {
    id: 3,
    invoice: 'POP2_M100520',
    driver: 'Robert Fox',
    img: 'https://themesbrand.com/minible/layouts/assets/images/users/avatar-2.jpg',
    customer: 'OEC Group',
    status: 'Dropped',
    movement: 'Movement',
    container: 'SDEE4125554',
    reference: 'SDEE4125554',
    billDate: '06/11',
    invoiceAmt: '00.00',
    paymentReceived: '00.00',
    outstanding: '00.00',
    payment: '0.00',
  },
  {
    id: 4,
    invoice: 'POP2_M100520',
    driver: 'Robert Fox',
    img: 'https://themesbrand.com/minible/layouts/assets/images/users/avatar-2.jpg',
    customer: 'OEC Group',
    status: 'Dropped',
    movement: 'Movement',
    container: 'SDEE4125554',
    reference: 'SDEE4125554',
    billDate: '06/11',
    invoiceAmt: '00.00',
    paymentReceived: '00.00',
    outstanding: '00.00',
    payment: '0.00',
  },
  {
    id: 5,
    invoice: 'POP2_M100520',
    driver: 'Robert Fox',
    img: 'https://themesbrand.com/minible/layouts/assets/images/users/avatar-2.jpg',
    customer: 'OEC Group',
    status: 'Dropped',
    movement: 'Movement',
    container: 'SDEE4125554',
    reference: 'SDEE4125554',
    billDate: '06/11',
    invoiceAmt: '00.00',
    paymentReceived: '00.00',
    outstanding: '00.00',
    payment: '0.00',
  },
  {
    id: 6,
    invoice: 'POP2_M100520',
    driver: 'Robert Fox',
    img: 'https://themesbrand.com/minible/layouts/assets/images/users/avatar-2.jpg',
    customer: 'OEC Group',
    status: 'Dropped',
    movement: 'Movement',
    container: 'SDEE4125554',
    reference: 'SDEE4125554',
    billDate: '06/11',
    invoiceAmt: '00.00',
    paymentReceived: '00.00',
    outstanding: '00.00',
    payment: '0.00',
  },
  {
    id: 7,
    invoice: 'POP2_M100520',
    driver: 'Robert Fox',
    img: 'https://themesbrand.com/minible/layouts/assets/images/users/avatar-2.jpg',
    customer: 'OEC Group',
    status: 'Dropped',
    movement: 'Movement',
    container: 'SDEE4125554',
    reference: 'SDEE4125554',
    billDate: '06/11',
    invoiceAmt: '00.00',
    paymentReceived: '00.00',
    outstanding: '00.00',
    payment: '0.00',
  },
  {
    id: 8,
    invoice: 'POP2_M100520',
    driver: 'Robert Fox',
    img: 'https://themesbrand.com/minible/layouts/assets/images/users/avatar-2.jpg',
    customer: 'OEC Group',
    status: 'Dropped',
    movement: 'Movement',
    container: 'SDEE4125554',
    reference: 'SDEE4125554',
    billDate: '06/11',
    invoiceAmt: '00.00',
    paymentReceived: '00.00',
    outstanding: '00.00',
    payment: '0.00',
  },
  {
    id: 9,
    invoice: 'POP2_M100520',
    driver: 'Robert Fox',
    img: 'https://themesbrand.com/minible/layouts/assets/images/users/avatar-2.jpg',
    customer: 'OEC Group',
    status: 'Dropped',
    movement: 'Movement',
    container: 'SDEE4125554',
    reference: 'SDEE4125554',
    billDate: '06/11',
    invoiceAmt: '00.00',
    paymentReceived: '00.00',
    outstanding: '00.00',
    payment: '0.00',
  },
  {
    id: 10,
    invoice: 'POP2_M100520',
    driver: 'Robert Fox',
    img: 'https://themesbrand.com/minible/layouts/assets/images/users/avatar-2.jpg',
    customer: 'OEC Group',
    status: 'Dropped',
    movement: 'Movement',
    container: 'SDEE4125554',
    reference: 'SDEE4125554',
    billDate: '06/11',
    invoiceAmt: '00.00',
    paymentReceived: '00.00',
    outstanding: '00.00',
    payment: '0.00',
  },
  {
    id: 11,
    invoice: 'POP2_M100520',
    driver: 'Robert Fox',
    img: 'https://themesbrand.com/minible/layouts/assets/images/users/avatar-2.jpg',
    customer: 'OEC Group',
    status: 'Dropped',
    movement: 'Movement',
    container: 'SDEE4125554',
    reference: 'SDEE4125554',
    billDate: '06/11',
    invoiceAmt: '00.00',
    paymentReceived: '00.00',
    outstanding: '00.00',
    payment: '0.00',
  },
  {
    id: 12,
    invoice: 'POP2_M100520',
    driver: 'Robert Fox',
    img: 'https://themesbrand.com/minible/layouts/assets/images/users/avatar-2.jpg',
    customer: 'OEC Group',
    status: 'Dropped',
    movement: 'Movement',
    container: 'SDEE4125554',
    reference: 'SDEE4125554',
    billDate: '06/11',
    invoiceAmt: '00.00',
    paymentReceived: '00.00',
    outstanding: '00.00',
    payment: '0.00',
  },
  {
    id: 13,
    invoice: 'POP2_M100520',
    driver: 'Robert Fox',
    img: 'https://themesbrand.com/minible/layouts/assets/images/users/avatar-2.jpg',
    customer: 'OEC Group',
    status: 'Dropped',
    movement: 'Movement',
    container: 'SDEE4125554',
    reference: 'SDEE4125554',
    billDate: '06/11',
    invoiceAmt: '00.00',
    paymentReceived: '00.00',
    outstanding: '00.00',
    payment: '0.00',
  },
  {
    id: 14,
    invoice: 'POP2_M100520',
    driver: 'Robert Fox',
    img: 'https://themesbrand.com/minible/layouts/assets/images/users/avatar-2.jpg',
    customer: 'OEC Group',
    status: 'Dropped',
    movement: 'Movement',
    container: 'SDEE4125554',
    reference: 'SDEE4125554',
    billDate: '06/11',
    invoiceAmt: '00.00',
    paymentReceived: '00.00',
    outstanding: '00.00',
    payment: '0.00',
  },
];

const options = [
  { value: 'jessica.hanson@example.com', label: 'jessica.hanson@example.com' },
  { value: 'john.doe@example.com', label: 'john.doe@example.com' },
  { value: 'alex@example.com', label: 'alex@example.com' },
];

const StaticTableContent = () => {
  const [showModal, setShowModal] = useState(false);

  const handleShowModal = (event) => {
    setShowModal(true);
  };

  const handleHideModal = (event) => {
    setShowModal(false);
  };

  return (
    <div className="table-responsive" style={{ height: 'calc(100vh - 272px)' }}>
      <table className="table table-card table-card--ls">
        <thead>
          <tr>
            <th>
              <input
                className="form-check-input rounded-3 border-secondary"
                type="checkbox"
                id="sr_no"
              />
            </th>
            {columns.map((column) => {
              return (
                <th scope="col" key={column}>
                  {column}
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {data.map((datum) => {
            return (
              <tr key={datum.id}>
                <td>
                  <input
                    className="form-check-input rounded-3 border-secondary"
                    type="checkbox"
                    id="sr_no"
                  />
                </td>
                <td>
                  <a
                    href="javascript:void(0)"
                    className="text-primary font-weight-500"
                  >
                    {datum.invoice}
                  </a>
                </td>
                <td>
                  <div className="d-flex">
                    <div className="mr-2 align-self-center">
                      <img
                        src={datum.img}
                        className="avatar-xs rounded-circle"
                        width="30"
                        alt=""
                      />
                    </div>
                    <h5 className="mb-0 align-self-center">
                      <a href="#" className="text-dark">
                        {datum.driver}
                      </a>
                    </h5>
                  </div>
                </td>
                <td>{datum.customer}</td>
                <td>
                  <div className="">{datum.movement}</div>
                </td>
                <td>
                  <div className="">
                    {datum.status == 'Dropped' && (
                      <span className="badge  badge-sm badge-green ">
                        {datum.status}
                      </span>
                    )}
                  </div>
                </td>

                <td>{datum.container}</td>
                <td>{datum.reference}</td>
                <td>{datum.billDate}</td>
                <td>${datum.invoiceAmt}</td>
                <td>${datum.paymentReceived}</td>
                <td>${datum.outstanding}</td>
                <td>${datum.payment}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default StaticTableContent;
